import { useTranslation } from 'react-i18next';
import { Fieldset, Radio, ValidationMessage } from '@digdir/designsystemet-react';
import { FieldPathByValue } from 'react-hook-form';
import { FC } from 'react';

import { useOppvarmingFormContext } from '../../utils';
import { JaNeiVetIkke } from '../../../../../../../components/registering/utils/registerEnums';
import { OppvarmingFormData } from '../../../types';

type JaNeiVetIkkePath = FieldPathByValue<OppvarmingFormData, JaNeiVetIkke>;

interface Props {
  name: JaNeiVetIkkePath;
}

//This component is currently the inverse of what the name says.
//It asks whether the heating central is NOT installed in a heated room.
//Therefore are labels and values inverted. Fix in january 2025 when the component.
// TODO: US18027
export const InstallertIOppvarmetRomRadio: FC<Props> = ({ name }) => {
  const { t } = useTranslation();
  const { register, getFieldState } = useOppvarmingFormContext();
  const { error } = getFieldState(name);

  return (
    <Fieldset>
      <Fieldset.Legend>{t('form.oppvarming.common.varmesentral.installertIOppvarmetRom.label')}</Fieldset.Legend>
      <Radio
        {...register(name, {
          required: t('form.oppvarming.common.varmesentral.installertIOppvarmetRom.error'),
          shouldUnregister: true
        })}
        label={t('form.common.yes')}
        value={JaNeiVetIkke.Nei}
        aria-invalid={!!error}
      />
      <Radio
        {...register(name, {
          required: t('form.oppvarming.common.varmesentral.installertIOppvarmetRom.error'),
          shouldUnregister: true
        })}
        label={t('form.common.no')}
        value={JaNeiVetIkke.Ja}
        aria-invalid={!!error}
      />

      {!!error?.message && <ValidationMessage data-color="danger">{error.message}</ValidationMessage>}
    </Fieldset>
  );
};
